module.exports = __webpack_public_path__ + "jsoneditor-icons.d961fdfabbe512d2675d.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/node_modules/jsoneditor/dist/img/jsoneditor-icons.svg
// module id = ../../../../jsoneditor/dist/img/jsoneditor-icons.svg
// module chunks = styles